<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>

<section>
  <div class="row no-mar-lr mar-tb-20">
    <div class="col-md-5">
      <span class="dta_title">{{'Monthly View' | translate}}</span>
    </div>
    <div class="col-md-7 pad-top-10 text-right">
      <a href="#/poFCMonthly" class="has-link">{{'Monthly View' | translate}}</a> |
      <a href="#/poFCJun" class="has-link">{{'Jun View' | translate}}</a> |
      <a href="#/poFCDaily" class="has-link">{{'Daily View' | translate}}</a> |
      <a href="#/poSummary" class="has-link">{{'Package Data Availability' | translate}}</a> |
      <a href="#/poDashboard" class="has-link">Back&nbsp;
        <i class="fa fa-reply" aria-hidden="true"></i>
      </a>
    </div>
  </div>

  <ul class="nav nav-tabs pad-top-40" role="tablist">
    <li class="nav-item" (click)="resetDD()">
      <a class="nav-link active" data-toggle="tab" href="#tableView" role="tab" #unlistDPNav>{{'Table View' | translate}}</a>
    </li>
    <li class="nav-item" (click)="resetDD()">
      <a class="nav-link" data-toggle="tab" href="#graphView" role="tab" #createDPNav>{{'Graph View' | translate}}</a>
    </li>
  </ul>

  <div class="tab-content">
    <div class="tab-pane pad-btm-30 active" id="tableView" #unlistDPPane>
      <section class="part_search_bar">
        <div class="row no-mar-lr">

          <div class="col-md-4 pad-top-30">
            <div class="row">
              <div class="col-md-5 text-right pad-top-5">
                {{'SUPPLIERCODE' | translate}} &nbsp;&nbsp;&nbsp;
              </div>
              <div class="col-md-5">
                <ng-multiselect-dropdown *ngIf="suppDD" #suppliercodeTbl="ngModel" name="suppliercodetbl" [(ngModel)]="suppCodeTbl"
                [settings]="dropdownSettings" [data]="suppDD" (onSelect)="onSupplierCodeSelect($event)" (onDeSelect)="OnSupplierCodeDeSelect($event)"
                  (onSelectAll)="onSupplierCodeSelectAll($event)" (onDeSelectAll)="onSupplierCodeDeSelectAll($event)">
                </ng-multiselect-dropdown>
              </div>
            </div>
          </div>
          <div class="col-md-4 pad-top-30">
            <div class="row">
              <div class="col-md-5 text-right pad-top-5">
                {{'Location Code' | translate}} &nbsp;&nbsp;&nbsp;
              </div>
              <div class="col-md-5">
                <ng-multiselect-dropdown *ngIf="locDD" #locationcodeTbl="ngModel" name="locationcodeTbl" [(ngModel)]="locCodeTbl"
                [settings]="dropdownSettings" [data]="locDD" >
                </ng-multiselect-dropdown>
              </div>
            </div>
          </div>
          <div class="col-md-3 pad-top-30">
            <button class="btn btn btn-dark" (click)="onChangeTable(config)">{{'Display' | translate}}</button>
          </div>
        </div>
      </section>
      <div class="row no-mar-lr mar-top-50">
        <div class="container">
          <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page" [totalItems]="length" [itemsPerPage]="itemsPerPage"
            [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
          </pagination>
          <ng-table [config]="config" (tableChanged)="onChangeTable(config)" [rows]="rows" [columns]="columns">
          </ng-table> -->

          <!-- <pagination *ngIf="config.paging" class="pad-top-10" [(ngModel)]="page" [totalItems]="length" [itemsPerPage]="itemsPerPage"
            [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
          </pagination> -->

          <div *ngIf="dataSource" class="example-container mat-elevation-z8">
          
            <!-- <mat-table [dataSource]="dataSource" matSort>
          
            
              <ng-container matColumnDef="supplierCode">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Code </mat-header-cell>
                <mat-cell *matCellDef="let value"> {{value.supplierCode}} </mat-cell>
              </ng-container>
          
             
              <ng-container matColumnDef="supplierName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> SupplierName </mat-header-cell>
                <mat-cell *matCellDef="let value"> {{value.supplierName}}</mat-cell>
              </ng-container>
          
             
              <ng-container matColumnDef="location">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Location</mat-header-cell>
                <mat-cell *matCellDef="let value"> {{value.location}} </mat-cell>
              </ng-container>
          
              
              <ng-container matColumnDef="fc1">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Month 1 </mat-header-cell>
                <mat-cell *matCellDef="let value" [style.color]="value.color"> {{value.fc1}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="fc2">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Month 2 </mat-header-cell>
                <mat-cell *matCellDef="let value" [style.color]="value.color"> {{value.fc2}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="fc2">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Month 3 </mat-header-cell>
                <mat-cell *matCellDef="let value" [style.color]="value.color"> {{value.fc3}} </mat-cell>
              </ng-container>
          
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;">
              </mat-row>
            </mat-table> -->
            <table>
              <th>Supplier Code</th>
              <th>Supplier Name</th>
              <th>Supplier Location</th>
              <th>Month 1</th>
              <th>Month 2</th>
              <th>Month 3</th>
              <tr *ngFor="let row of data">
                <td>{{row.supplierCode}}</td>
                <td>{{row.supplierName}}</td>
                <td>{{row.location}}</td>
                <td><div [innerHTML]="row.fc1"></div></td>
                <td><div [innerHTML]="row.fc2"></div></td>
                <td><div [innerHTML]="row.fc3"></div></td>
              </tr>
            </table>
          
          
          </div>
          
          <div class="noRecords" *ngIf="rows.length == 0"> {{'No Records Found' | translate}}! </div>
        </div>
        <div class="col-md-3">
        </div>
      </div>
    </div>
    <div class="tab-pane pad-btm-30" id="graphView" #createDPPane>
      <section class="part_search_bar">
        <div class="row no-mar-lr">
          <div class="col-md-4 pad-top-30">
            <div class="row">
              <div class="col-md-5 text-right pad-top-5">
                {{'SUPPLIERCODE' | translate}} &nbsp;&nbsp;&nbsp;
              </div>
              <div class="col-md-5">
                <p-dropdown [options]="graphSuppDD" [(ngModel)]="supPoint" [filter]="true" [style]="{'width':'100%'}" (onChange)="onGraphSuppSel($event)"
                  placeholder="Select Supplier Code"></p-dropdown>
              </div>
            </div>
          </div>
          <div class="col-md-4 pad-top-30">
            <div class="row">
              <div class="col-md-5 text-right pad-top-5">
                {{'Location Code' | translate}} &nbsp;&nbsp;&nbsp;
              </div>
              <div class="col-md-5">
                <ng-multiselect-dropdown *ngIf="locDD" #locationcodeGrph="ngModel" name="locationcodeGrph" [data]="locDD" [(ngModel)]="locCode"
                  [settings]="graphLocStg">
                </ng-multiselect-dropdown>
              </div>
            </div>
          </div>
          <div class="col-md-3 pad-top-30">
            <button class="btn btn btn-dark" (click)="showGraphData()" [disabled]="graphDispBtn">{{'Display' | translate}}</button>
          </div>
        </div>
      </section>

      <div class="container no-mar-lr">
          <div class="row mar-top-40">
              <div class="offset-md-3 col-md-4" *ngIf="resultData != undefined">
                  <strong>{{'SUPPNAME[Eng]' | translate}} : {{resultData.supplierNameEN}}</strong>
                </div>
                <div class="col-md-4" *ngIf="resultData != undefined">
                  <strong>{{'SUPPNAME[Jap]' | translate}}: {{resultData.supplierNameJP}}</strong>
                </div>
          </div>
        <div class="row">
         
          <div class="col-md-6">
            <div class="panel panel-default mar-top-40">
              <div class="panel-heading bgWhite">
                <b class="panelTitle">{{'Volume' | translate}} (m3)</b>
              </div>
              <div class="panel-body">
                <div *ngIf="VolumeChartData.length > 0">
                  <canvas *ngIf="VolumeChartData" baseChart [datasets]="VolumeChartData" [labels]="monthLabels" [options]="stackChartOpt" [legend]="barChartLegend"
                    [colors]="lineChartColors" [chartType]="barChartType"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mar-top-40">
            <table class="table table-bordered">
              <thead class="bg-gray">
                <tr>
                  <th class="text-center" >{{'Location' | translate}}</th>
                  <th class="text-center">{{firstMonthData}}</th>
                  <th class="text-center">{{secondMonthData}}</th>
                  <th class="text-center">{{thirdMonthData}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of monthDetails">
                  <td class="text-center">{{data.plantName}}</td>
                  <td class="text-center">{{data.forcastFirstMonthVolume | number : '1.2-2'}}</td>
                  <td class="text-center">{{data.forcastSecondMonthVolume | number : '1.2-2'}}</td>
                  <td class="text-center">{{data.forcastThirdMonthVolume | number : '1.2-2'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="panel panel-default mar-top-40">
              <div class="panel-heading bgWhite">
                <b class="panelTitle">{{'Weight' | translate}} (Kg)</b>
              </div>
              <div class="panel-body">
                <div *ngIf="WeightChartData.length > 0">
                  <canvas *ngIf="WeightChartData" baseChart [datasets]="WeightChartData" [labels]="monthLabels" [options]="stackChartOpt" [legend]="barChartLegend"
                    [colors]="lineChartColors" [chartType]="barChartType"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6  mar-top-40">
              <table class="table table-bordered">
                  <thead class="bg-gray">
                    <tr>
                      <th class="text-center">{{'Location' | translate}}</th>
                      <th class="text-center">{{firstMonthData}}</th>
                      <th class="text-center">{{secondMonthData}}</th>
                      <th class="text-center">{{thirdMonthData}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of monthDetails">
                      <td class="text-center">{{data.plantName}}</td>
                      <td class="text-center">{{data.forcastFirstMonthWeight | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.forcastSecondMonthWeight | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.forcastThirdMonthWeight | number : '1.2-2'}}</td>
                    </tr>
                  </tbody>
                </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="panel panel-default mar-top-40">
              <div class="panel-heading bgWhite">
                <b class="panelTitle">{{'Quantity' | translate}}</b>
              </div>
              <div class="panel-body">
                <div *ngIf="QuantityChartData.length > 0">
                  <canvas *ngIf="QuantityChartData" baseChart [datasets]="QuantityChartData" [labels]="monthLabels" [options]="stackChartOpt"
                    [legend]="barChartLegend" [colors]="lineChartColors" [chartType]="barChartType"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6  mar-top-40">
              <table class="table table-bordered">
                  <thead class="bg-gray">
                    <tr>
                      <th class="text-center">{{'Location' | translate}}</th>
                      <th class="text-center">{{firstMonthData}}</th>
                      <th class="text-center">{{secondMonthData}}</th>
                      <th class="text-center">{{thirdMonthData}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of monthDetails">
                      <td class="text-center">{{data.plantName}}</td>
                      <td class="text-center">{{data.forcastFirstMonthQuantity | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.forcastSecondMonthQuantity | number : '1.2-2'}}</td>
                      <td class="text-center">{{data.forcastThirdMonthQuantity | number : '1.2-2'}}</td>
                    </tr>
                  </tbody>
                </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>